import React from "react";
import {useSelector} from "react-redux";

function Loader({children}) {
    const isLoad = useSelector(({searchReducer}) => searchReducer.isLoad);
    return (
        <React.Fragment>
            {children}
            {isLoad
                ? <>
                    <div className="search__loader">
                        <div className="loader"/>
                    </div>
                    {/* <div className="search__greyscreen">

          </div> */}

                </>
                : null}
        </React.Fragment>
    );
}

export default Loader;
